
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class SearchService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
    }

    user(query?: any) {
        return this.get('/search/user',query);
    }
    
    all(body?: any) {
        return this.post('/search', body)
    }
    createFilter(body) {
        return this.post('/create-filter', body);
    }

    deleteFilter(filter_id) {
        return this.delete('/delete-filter/'+filter_id);
    }

    updateFilter(filter_id, body) {
        return this.put('/update-filter/'+filter_id, body);
    }
    listFilter(query = {}) {
        return this.get('/list-filter',query);
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/Search.service.ts